/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    "verification-types": {
        menu: {
            index: 'KYC',
            create: 'New type',
            list: 'KYC'
        },
        table_titles: {
            id: 'ID',
            country: 'Country',
            communication_type: 'Communication type',
            kyc_method: 'KYC method',
            instructions: 'Instructions',
            dialog_content: 'Dialog content',
            on_review_email_content: 'On review email content',
            status: 'Status',
            setting: 'Edit / Delete',
        },
        edit: 'Edit verification type'
    }
}
